export default "__VITE_ASSET__0Mwieiqx__"